import { useMemoizedContentGetter } from 'utils/contentful'
import { Typography, LinkButton } from 'components/Contentful'
import Section from 'components/Section'
import styles from './CloserStatementSection.module.scss'
import { Grid } from '@achieve/ascend'
import classNames from 'classnames'

function CloserStatementSectionModule({ title, background, button, config = {} }) {

  return (
    <Section
      childContainerClassName={styles['closer-statement-child-section']}
      className={styles['closer-statement-section']}
      data-testid="closer-statement-section"
      mediaContent={background?.mediaContent}
      middleMediaContent={background?.mobileMediaContent}
      mobileMediaContent={background?.mobileMediaContent}
      backgroundImageAlt={background?.mediaAltText}
      backgroundObjectPositionClass={`bg-bottom lg:bg-top`}
      full={true}
    >
      <Grid
        container
        alignItems="center"
        className={classNames(styles['outer-grid-container'], 'flex-col lg:flex-row')}
        data-testid="closer-statement-outer-grid-container"
        data-right-content={config?.rightContent}
      >
        <Grid
          item
          xs={8}
          xl={6.5}
          className={styles['grid-item-text']}
          data-testid="closer-statement-grid-item-text"
        >
          <div className={styles['text-container']} data-testid="closer-statement-text-container">
            <Typography
              content={title?.textContent}
              variant="headingLg"
              fontWeight="bold"
              className={styles['title']}
            />
            <div className={styles['cta-container']}>
              {button && (
                <LinkButton
                  className={styles['button']}
                  content={button}
                  typographicOptions={{
                    className: 'bodySm lg:bodyLg font-bold',
                    'data-testid': 'closer-statement-button-text',
                  }}
                  size="medium"
                  color="secondary"
                  data-testid="closer-statment-button"
                  track={{
                    ...{
                      click_id: button?.linkText?.json?.content[0]?.content[0]?.value,
                      click_text: button?.linkText?.json?.content[0]?.content[0]?.value,
                      list_name: 'Product Page Closer',
                      click_url: button?.linkHref,
                      nav_link_section: 'Closer Statement',
                      track_event: 'internal_campaign_click',
                      click_type: 'Button Click',
                      event_action: 'button_click',
                      event_type: 'button_click',
                    },
                    ...button.event,
                  }}
                />
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </Section>
  )
}

function CloserStatementSection({ content }) {
  const { title, background, button, config } = useMemoizedContentGetter(content, [
    'title',
    'background',
    'button',
    'config',
  ])

  return (
    <CloserStatementSectionModule
      title={title}
      background={background}
      button={button}
      config={config?.jsonContent}
    />
  )
}
export { CloserStatementSection, CloserStatementSectionModule }
export default CloserStatementSection
